import "@ionic/core";
//# sourceMappingURL=global.js.map
